import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Sidebar() {
  const [loginUserRole, setLoginUserRole] = useState("");
  const [companyId, setCompanyId] = useState("");
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("userVASData");
    localStorage.removeItem("companyData");
    localStorage.removeItem("companyVASData");
    localStorage.removeItem("companyName"); // userDataFs
    navigate("/login");
  };

  // console.log("company id ", companyId);

  useEffect(() => {
    // Retrieve userVASData from local storage
    const storedUserData = localStorage.getItem("userVASData");
    // console.log("Stored userVASData:", storedUserData);

    if (storedUserData) {
      try {
        // Parse the JSON string to an object
        const parsedData = JSON.parse(storedUserData);

        // Access companyId and roles
        const id = parsedData.responseDetails?.id;
        const userRoles = parsedData.responseDetails?.roles;

        // console.log("Retrieved companyIdcccc:", companyId);
        // console.log("Retrieved user roles:", userRoles);

        // Use the retrieved data as needed
        if (id) {
          // console.log("Retrieved id from localStorage:", id);
          setCompanyId(id);
        }

        if (userRoles && userRoles.length > 0) {
          setLoginUserRole(userRoles[0]);
        }
      } catch (error) {
        console.error("Error parsing storedUserData:", error);
      }
    }
  }, []);

  return (
    <div className="dlabnav">
      <div className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          <li className="nav-label first">Main Menu</li>
          {loginUserRole == "Admin" ? (
            <li>
              <Link to="/dashboard" className="ai-icon" aria-expanded="false">
                <i className="la la-home"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>
          ) : null}
          {loginUserRole == "CompanyUser" ? (
            <li>
              <Link
                to="/dashboard/company"
                className="ai-icon"
                aria-expanded="false"
              >
                <i className="la la-home"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>
          ) : null}

          {/* <li>
            <Link to="/revenue/" className="ai-icon" aria-expanded="false">
              <i className="la la-money-bill-alt"></i>
              <span className="nav-text">Revenues</span>
            </Link>
          </li> */}
          {loginUserRole == "Admin" ? (
            <li>
              <Link to="/company" className="ai-icon" aria-expanded="false">
                <i className="la la-building"></i>
                <span className="nav-text">Company</span>
              </Link>
            </li>
          ) : null}

          {loginUserRole === "Admin" ? (
            <li>
              <Link to="/products" className="ai-icon" aria-expanded="false">
                <i className="la la-shopping-bag"></i>
                <span className="nav-text">Products</span>
              </Link>
            </li>
          ) : null}

          {loginUserRole == "Admin" ? (
            <li>
              <Link to="/test" className="ai-icon" aria-expanded="false">
                <i className="la la-phone"></i>
                <span className="nav-text">Test Mode</span>
              </Link>
            </li>
          ) : null}

          {loginUserRole == "Admin" ? (
            <li>
              <Link to="/channels" className="ai-icon" aria-expanded="false">
                <i className="la la-list-alt"></i>
                <span className="nav-text">Manage Channels</span>
              </Link>
            </li>
          ) : null}

          {loginUserRole == "Admin" ? (
            <li>
              <Link to="/games" className="ai-icon" aria-expanded="false">
                <i className="la la-gamepad"></i>
                <span className="nav-text">Partner Games</span>
              </Link>
            </li>
          ) : null}

          {loginUserRole == "CompanyUser" ? (
            <li>
              <Link
                to={{
                  pathname: "/marketers",
                  state: { id: companyId }, // Passing companyId in the state
                }}
                // state={{ rowData: companyId }}
                className="ai-icon"
                aria-expanded="false"
              >
                <i className="la la-building"></i>
                {/* <span className="nav-text">Filter</span> */}
                <span className="nav-text">Marketers</span>
              </Link>
            </li>
          ) : null}
          <li>
            <Link
              to={{
                pathname: "/filter/data",
                state: { id: companyId }, // Passing companyId in the state
              }}
              // state={{ rowData: companyId }}
              className="ai-icon"
              aria-expanded="false"
            >
              <i className="la la-th-list"></i>
              <span className="nav-text">Filter Data</span>
            </Link>
          </li>

          <li>
            <Link
              to={{
                pathname: "/download/data",
                state: { id: companyId }, // Passing companyId in the state
              }}
              // state={{ rowData: companyId }}
              className="ai-icon"
              aria-expanded="false"
            >
              <i className="la la-download"></i>
              <span className="nav-text">Download data</span>
            </Link>
          </li>
          <li>
            <Link onClick={logout} to="/">
              <i className="la la-power-off"></i>
              <span className="nav-text">Logout</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
